import { TableCard } from 'app/components'
import { LogsAtendimentoHeading } from './components/LogsAtendimentoHeading'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { LogsConsultaIdTable } from './table/LogsConsultaIdTable'

const LogsConsultaIdList = () => {
  return (
    <>
      <LogsAtendimentoHeading />
      <TableCard>
        <LogsConsultaIdTable />
      </TableCard>
    </>
  )
}

export const LogsConsultaIdListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <LogsConsultaIdList />
    </QueryResponseProvider>
  </QueryRequestProvider>
)
